import React from 'react';
import { SharedModifierDetails } from './components/sharedModifierDetails/SharedModifierDetails';

export const CreateSharedModifierPage = () => {
  return <SharedModifierDetails />;
};
